import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
  @Input()
  title: String;
  content: String;
  cancelButton: String = 'Batal';
  confirmButton: String = 'Ya';
  withInput: Boolean = false;
  inputPlaceholder: String = '';
  inputValue: String;
  isShowAlert: boolean = false;
  alertMessage: string = '';
  alertIcon: string = '';
  alertStatus: string = '';

  constructor(protected ref: NbDialogRef<ConfirmDialogComponent>) {}

  ngOnInit(): void {}

  cancel() {
    this.ref.close({ event: false });
  }

  confirm() {
    this.ref.close({ event: true, data: this.inputValue });
  }
}
